export const DASHBOARD_CONTENT = {
  cards: [
    {
      head: 'Overall Position',
      subText: '2nd',
      color: '#8A70D6',
      color2: '#BDA6FF',
      path: '#',
    },
    {
      head: 'Total Subjects',
      subText: '12',
      color: '#FCAB5E',
      color2: '#FFCFA2',
      path: '#',
    },
  ],
  tableData: {
    head: ['Title', 'Grade', 'Status'],
    body: [
      {
        bodyHead: {
          headTitle: 'Fun Fact About Australia',
          headText: 'Tue 12, 2022',
        },
        bodyItems: ['0/10', 'Pending'],
      },
      {
        bodyHead: {
          headTitle: 'Verbal Abtitude',
          headText: 'Tue 12, 2022',
        },
        bodyItems: ['8/10', 'Completed'],
      },
      {
        bodyHead: {
          headTitle: 'Physics Assignment',
          headText: 'Tue 12, 2022',
        },
        bodyItems: ['9/10', 'Completed'],
      },
      {
        bodyHead: {
          headTitle: 'Physics Assignment',
          headText: 'Tue 12, 2022',
        },
        bodyItems: ['9/10', 'Completed'],
      },
    ],
  },
  events: [
    {
      date1: 2,
      date2: 'jan',
      title: 'Principal Football Cup',
      time: '10am',
      color: '#5792F0',
    },
    {
      date1: 23,
      date2: 'jan',
      title: 'Inter House Sport',
      time: '10am',
      color: '#FFB0C8',
    },
    {
      date1: 15,
      date2: 'Feb',
      title: 'Swimming Class',
      time: '4pm',
      color: '#B395F3',
    },
    {
      date1: 28,
      date2: 'Feb',
      title: 'Visitation to the Zoo',
      time: '3pm',
      color: '#E9B575',
    },
    {
      date1: 28,
      date2: 'Feb',
      title: 'Excursion to Aso Rock',
      time: '11am',
      color: '#E9B575',
    },
  ],
}
